/**
 * Build the guided-tour context for a brightmark annotation captured during a
 * tour (#1979, D4-FBK-033).
 *
 * Pure + DOM-free: it reads the live ``useTour()`` value and returns the nested
 * ``tour`` object the annotation carries, or ``null`` when no tour is running
 * (or there is no current step) so a non-tour annotation omits the block and the
 * contract stays backward compatible.
 */
import type { TourAnnotationContext } from "./types";

/** The slice of the tour context this helper needs (kept structural for testing). */
export interface TourSnapshotSource {
  isRunning: boolean;
  activeTourId: string | null;
  stepIndex: number;
  stepCount: number;
  currentStep: {
    id: string;
    target: string;
    route: string;
    kind?: "page" | "action";
  } | null;
}

export function buildTourContext(
  tour: TourSnapshotSource,
): TourAnnotationContext | null {
  if (!tour.isRunning || !tour.activeTourId || !tour.currentStep) return null;
  const step = tour.currentStep;
  return {
    tour_id: tour.activeTourId,
    step_index: tour.stepIndex,
    step_count: tour.stepCount,
    step_id: step.id,
    step_target: step.target ?? null,
    step_kind: step.kind ?? "page",
    route: step.route,
  };
}
